import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const clashDetailsSlice = createSlice({
  name: "clashDetails",
  initialState: { isFetch: false },
  reducers: {
    setClashDetails: (_state: any, action: PayloadAction<any>) => ({ ...action.payload, isFetch: true }),
    setClashSettings: (_state: any, action: PayloadAction<any>) => ({
      ..._state,
      settings: { ..._state?.settings, ...action.payload },
    }),
    resetClashDetails: (_state, _action: PayloadAction<void>) => ({ isFetch: false }),
  },
});

export const { setClashDetails, setClashSettings, resetClashDetails } = clashDetailsSlice.actions;

export const clashDetails = clashDetailsSlice.reducer;

export default {
  clashDetails,
};
